module.exports = "<button class=\"btn btn-default\" type=\"button\" ng-disabled=\"disabled\" translate>\r\n    Cancel\r\n</button>";